// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3ayUO","rootSuccess":"CompleteLink_rootSuccess__1jfg-","rootFailure":"CompleteLink_rootFailure__2mZNu","isDisabled":"CompleteLink_isDisabled__w0vM7"};